import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import AuditReportView from "@/components/AuditReportView";
import { getAuditReport } from "@/lib/api";

export default function AuditReportPage() {
  const { reportId } = useParams();
  const [state, setState] = useState({ status: "loading", report: null });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await getAuditReport(reportId);
        if (!cancelled) setState({ status: "ready", report: r });
      } catch (e) {
        if (cancelled) return;
        if (e?.response?.status === 423) {
          setState({ status: "pending_review", report: null });
        } else {
          setState({ status: "error", report: null });
        }
      }
    })();
    return () => { cancelled = true; };
  }, [reportId]);

  return (
    <>
      <Nav />
      <div className="pt-32 pb-24 max-w-[1200px] mx-auto px-6 md:px-10">
        {state.status === "loading" && (
          <div className="flex items-center gap-3 text-[#404040] font-mono-tech text-[13px]">
            <Loader2 size={16} className="animate-spin text-[#e88a51]" /> Retrieving your audit…
          </div>
        )}
        {state.status === "pending_review" && (
          <div className="card-cream p-8" data-testid="audit-pending-review">
            <div className="tick mb-3 text-[#9a3412]">With the analyst</div>
            <p className="font-mono-tech text-[13px] text-[#404040]">
              Your waterfall is computed, but the analyst reviews every audit before it's released.
              Check back on My Account shortly.
            </p>
          </div>
        )}
        {state.status === "error" && (
          <div className="card-cream p-8">
            <div className="tick mb-3">Could not load this audit</div>
            <p className="font-mono-tech text-[13px] text-[#404040]">
              Sign in with the account you purchased with, or contact the analyst if this persists.
            </p>
          </div>
        )}
        {state.status === "ready" && state.report && <AuditReportView report={state.report} />}
      </div>
      <Footer />
    </>
  );
}
